import { useTranslation } from 'react-i18next'
import { useEditChatMutation } from 'api/mutations/chat/chat'
import { ChatHistoryItem } from 'api/queries/chat/types'
import { EditChatForm } from 'components/forms/EditChatForm/EditChatForm'
import { Modal } from 'components/layout/Modal/Modal'

interface EditChatModalProps {
  chat: ChatHistoryItem
  onClose: () => void
}

const EditChatModal = ({ chat, onClose }: EditChatModalProps) => {
  const { t } = useTranslation()
  const { mutate, isLoading } = useEditChatMutation({ onSuccess: onClose })
  const handleClose = () => {
    if (!isLoading) onClose()
  }

  return (
    <Modal
      open
      onClose={handleClose}
      isCloseDisabled={isLoading}
      role='dialog'
      aria-labelledby='edit-chat-modal-title'
    >
      <Modal.Title id='edit-chat-modal-title'>{t('aiChat.history.editTitle')}</Modal.Title>
      <EditChatForm
        title={chat.title}
        isLoading={isLoading}
        onSave={(title) => mutate({ id: chat.id, title })}
        onCancel={handleClose}
      />
    </Modal>
  )
}

export { EditChatModal }
